module.exports = __webpack_public_path__ + "static/media/Casual_2_no_bg.38aa5b66.png";